import lozad from 'lozad';

const observer = lozad();
observer.observe();



// MOBILE MENU
  const nav = document.querySelector('#nav-mobile');
  const menu = document.querySelector('#menu-mobile');
  const menuToggle = document.querySelector('.nav__toggle');
  const menuItem = document.querySelectorAll('.nav__item');
  let isMenuOpen = false;


  // TOGGLE MENU ACTIVE STATE
  menuToggle.addEventListener('click', e => {
    e.preventDefault();
    isMenuOpen = !isMenuOpen;
    
    // toggle a11y attributes and active class
    menuToggle.setAttribute('aria-expanded', String(isMenuOpen));
    //menu.hidden = !isMenuOpen;
    nav.classList.toggle('nav--open');
    menu.classList.toggle('menu--open');
  });

  // TOGGLE MENU IF CLICK ON LINK
  for (var i = 0; i < menuItem.length; i++) {
    menuItem[i].addEventListener('click', function() {
        if (isMenuOpen) {
          isMenuOpen = !isMenuOpen;

          // toggle a11y attributes and active class
          menuToggle.setAttribute('aria-expanded', String(isMenuOpen));
          //menu.hidden = !isMenuOpen;
          nav.classList.toggle('nav--open');
          menu.classList.toggle('menu--open');
        }
    });
  }